import '../../../filtersGrid.scss';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import SearchButton from '../../../../components/SearchButton/SearchButton';
import EmpleadosModal from '../../../empleados/empleadosModal/empleadosModal';

Modal.setAppElement('#root');

const FiltersGrid = ({
  searchInputRef,
  searchTerm,
  setSearchTerm,
  onSearch,
  onClose,
  setSearchIDFilter,
  setSearchDescFilter,
  searchDescFilter }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (!isSmallScreen) {
      setIsModalOpen(false); // Cierra el modal al cambiar a pantallas grandes
    }
  }, [isSmallScreen]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleClearFilters = () => {
    setSearchTerm("");
    setSearchIDFilter?.("");
    setSearchDescFilter?.("");
  };

  const renderModals = () => (
    <EmpleadosModal
      handleChange={(id) => setSearchIDFilter(id)}
      handleDescChange={(desc) => setSearchDescFilter(desc)}
      descSelected={searchDescFilter}
    />
  );

  return (
    <div className="filterContainer">
      {isSmallScreen ? (
        <>
          <button className="filterButton" onClick={handleOpenModal}>
            Filtros De Búsqueda
          </button>

          <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            contentLabel="Seleccionar Filtros"
            className="modalScreen"
            overlayClassName="overlayScreen"
          >
            <h2>Filtros de Búsqueda</h2>
            <div className="modalContent">
              <SearchButton
                searchInputRef={searchInputRef}
                searchTerm={searchTerm} // Muestra el valor del filtro actual
                onSearch={onSearch}
                onChange={setSearchTerm}
                onClose={() => {
                  setSearchDescFilter(""); // Limpia el filtro
                  onClose();
                }}
                tipo={0}
              />
              {renderModals()}
            </div>

            <div style={{ marginTop: "15px", textAlign: "center" }}>
              <button
                type="button"
                className="clearFiltersButton"
                onClick={handleClearFilters}
              >
                Limpiar filtros
              </button>
            </div>
            <button className="modalCloseButton" onClick={handleCloseModal}>
              ❌
            </button>
          </Modal>
        </>
      ) : (
        <>
          <div className="searchContainer">
            <SearchButton
              searchInputRef={searchInputRef}
              searchTerm={searchTerm} // Muestra el valor del filtro actual
              onSearch={onSearch}
              onChange={setSearchTerm}
              onClose={() => {
                setSearchDescFilter(""); // Limpia el filtro
                onClose();
              }}
              tipo={0}
            />
            {renderModals()}
            <div className="filtersActions">
              <button
                type="button"
                className="clearFiltersButton"
                onClick={handleClearFilters}
              >
                Limpiar filtros
              </button>
            </div>

          </div>
        </>
      )}
    </div>
  );
};

export default FiltersGrid;
